import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../lib/auth";
import { useUserState } from "../../../providers/UserProvider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import logo from "../../../assets/images/logo-s.png";
import classes from "./MenuItems.module.scss";
import { ReactComponent as Home } from "../../../assets/images/menuItemIcons/home.svg";
// import { ReactComponent as Help } from "../../assets/images/menuItemIcons/help.svg";
import { ReactComponent as NewVisit } from "../../../assets/images/menuItemIcons/newVisit.svg";
import { ReactComponent as Group } from "../../../assets/images/menuItemIcons/group-12.svg";
import { ReactComponent as ListIcon } from "../../../assets/images/menuItemIcons/list-icon.svg";
import { ReactComponent as Profile } from "../../../assets/images/menuItemIcons/profile.svg";
import { ReactComponent as Settings } from "../../../assets/images/menuItemIcons/settings.svg";
import sampleUser from "../../../assets/images/sampleUser/118-118.png";

function MenuItems() {
  const { t } = useTranslation();
  const user = useUserState();
  const [anchorEl, setAnchorEl] = React.useState(null);

  let auth = useAuth();
  function signOut() {
    auth.signout();
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderMenu = () => {
    if (user) {
      let userType = user.user_login.approve;
      if (userType === "doctor") {
        return (
          <>
            <NavLink
              to="/dashboard"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <Home />
            </NavLink>
            <NavLink
              to="/set-calendar"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <Group />
            </NavLink>
            <NavLink
              to="/doctor-info"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <ListIcon />
            </NavLink>
            <NavLink
              to="/profile"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <Profile />
            </NavLink>
            <NavLink
              to="/transactions"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <ListIcon />
            </NavLink>

            <NavLink
              to="/dr-settings"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <Settings />
            </NavLink>
            <NavLink to="#" className={classes.navLink}>
              <img
                src={sampleUser}
                onClick={handleClick}
                className={classes.userImg}
                alt="user"
              />
              <div className={classes.navTiltleShow}>sign out</div>
            </NavLink>
          </>
        );
      }

      if (userType === "user") {
        return (
          <>
            <NavLink
              to="/dashboard"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <div className={classes.navTiltleShow}>dashboard</div>
              <Home />
            </NavLink>
            <a
              href="https://sbm24.com/"
              target="_blank"
              rel="noreferrer"
              className={classes.navLink}
            >
              <div className={classes.navTiltleShow}>new visit</div>
              <NewVisit />
            </a>
            <NavLink
              to="/medical-history"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <div className={classes.navTiltleShow}>medical history</div>
              <Group />
            </NavLink>
            {/* <NavLink
              to="/increase-credit"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <ListIcon />
            </NavLink>
            <NavLink
              to="/withdrawal-request"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <ListIcon />
            </NavLink> */}
            <NavLink
              to="/patient-transactions"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <div className={classes.navTiltleShow}>transactions</div>
              <ListIcon />
            </NavLink>
            <NavLink
              to="/profile"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <div className={classes.navTiltleShow}>profile</div>
              <Profile />
            </NavLink>
            <NavLink
              to="/patient-settings"
              className={classes.navLink}
              activeClassName={classes.selected}
            >
              <div className={classes.navTiltleShow}>settings</div>
              <Settings />
            </NavLink>
            <NavLink to="#" className={classes.navLink}>
              <img
                src={sampleUser}
                onClick={handleClick}
                className={classes.userImg}
                alt="user"
              />
              <div className={classes.navTiltleShow}>sign out</div>
            </NavLink>
          </>
        );
      }
    }
  };
  return (
    <div className={classes.flexContainer}>
      <a href="https://sbm24.com/">
        <div>
          <img className={classes.logo} src={logo} alt="logo" />
        </div>
      </a>
      {renderMenu()}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={signOut}>
          {t("components.Layout.MenuItems.logout")}
        </MenuItem>
      </Menu>
    </div>
  );
}

export default MenuItems;
